import type { PPProviderBehavior } from '../types';
import { CISConfigType } from '../../typegen/cis-config-type';

export const invoiceCloudV1PPBehavior: PPProviderBehavior = {
	label: 'InvoiceCloud V1',
	requiresPrepareTransaction: true,
	cardPrepareAutoStart: true,
	buildPrepareCheckRequest(ctx) {
		return {
			accountsToPay: ctx.cartItems.map((item) => ({
				accountNumber: item.item.itemNumber,
				amount: item.amountToPay,
				invoiceGuid: item.item.itemGuid,
				icAchPaymentId: item.item.icAchPaymentId,
			})),
			paymentType: 'ECHECK',
			location: ctx.kioskLocation,
			totalAmount: ctx.cartTotalAmount,
			payorInfo: ctx.payorInformation,
		};
	},
	buildPrepareCardRequest(ctx) {
		return {
			accountsToPay: ctx.cartItems.map((item) => ({
				accountNumber: item.item.itemNumber,
				amount: item.amountToPay,
				invoiceGuid: item.item.itemGuid,
				icCcPaymentId: item.item.icCcPaymentId,
				creditTypeId: item.item.creditCardTypeId,
			})),
			paymentType: 'CREDIT',
			location: '',
			totalAmount: ctx.cartTotalAmount,
			payorInfo: ctx.payorInformation,
		};
	},
	getCashInvoiceGuid(item) {
		return item.itemGuid || null;
	},
	getReceiptInvoiceNumber(item, _cartId, obscure) {
		if (item.itemGuid) return item.itemGuid;
		return obscure ? (item.obscuredItemNumber ?? item.itemNumber) : item.itemNumber;
	},
	getTestPanelConfig(cisType) {
		return {
			show: cisType !== CISConfigType.InvoiceCloudV1 && cisType !== CISConfigType.InvoiceCloudV2,
			altText: 'InvoiceCloud',
		};
	},
	cardDeviceDisplayName: 'MagTek',
	requiresPayorInformation: false,
};
